import theme from 'antd/es/theme';
import { ThemeProvider } from 'styled-components';

export function StyledComponentsThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { token } = theme.useToken();
  return <ThemeProvider theme={token}>{children}</ThemeProvider>;
}
